import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';

import GET_ORDER_EXTRA_DATA_QUERY from 'Jsx/CheckoutV4/Graphql/Query/GetOrderExtraData.payments.graphql';

import { GetOrderExtraDataQuery } from '../Graphql/Query/types/GetOrderExtraDataQuery';

export interface CustomerExtraData {
  document: string;
  zipCode: string;
  address: string;
  city: string;
  phoneNumber: string;
  fullName: string;
}

const useCustomerExtraData = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [customerExtraData, setCustomerExtraData] =
    useState<CustomerExtraData>();
  const { data, error, loading } = useQuery<GetOrderExtraDataQuery>(
    GET_ORDER_EXTRA_DATA_QUERY,
    {
      context: { clientName: 'payments' },
    },
  );

  useEffect(() => {
    if (data && data.orderExtraData) {
      const { address, cep, city, document, phoneNumber, fullName } =
        data.orderExtraData;

      setCustomerExtraData({
        document: document || '',
        zipCode: cep || '',
        address: address || '',
        city: city || '',
        phoneNumber: phoneNumber || '',
        fullName: fullName || '',
      });
    }

    if (!loading) setIsLoading(false);
  }, [data, loading]);

  return { customerExtraData, loading: isLoading, error };
};

export default useCustomerExtraData;
